/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
import { ModulePropertySpecification, ModuleWidget } from './module-control-specification.model';

export class ModuleSpecification {
    id?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    spec: SpecificationSection<SpecProperty<any>> = new SpecificationSection<SpecProperty<any>>();
    ui?: SpecificationSection<UIProperty>;
    requirements?: ModuleRequirements;
    image?: string;
}

export class SpecificationSection<T> {
    inputs: { [key: string]: T } = {};
    outputs: { [key: string]: T } = {};
}

export class ModuleRequirements {
    hardware?: { gpu?: {} };
    network?: { internet_access?: {} };
}

export interface SpecProperty<T> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    default?: T | any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    depends_on?: string[] | any;
    [type: string]: ModulePropertySpecification;
}

export interface UIProperty {
    index: number;
    label: string;
    description?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [type: string]: any | ModuleWidget;
}
